let tribe = {};

tribe = require('../data/tribe')

module.exports = tribe;